import React, { FC, ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { TopArticlesCardType } from 'sections/Home/types';
import { BlogPosts } from 'components/BlogPosts';
import styles from 'sections/Resources/FreightTemplates/FreightQuotation/components/SectionRelatedPosts/SectionRelatedPosts.module.scss';

const cn = classNames.bind(styles);

interface SectionRelatedPostsProps {
  articles: TopArticlesCardType[];
};

const SectionRelatedPosts: FC<SectionRelatedPostsProps> = ({ articles }): ReactElement => {
  return (
    <section className={cn('related-posts')}>
      <div className={cn('container')}>

        <div className={cn('related-posts__heading-container')}>
          <h2 className={cn('related-posts__heading')}>Related blogs</h2>
          <Link href="/blog" className={cn('related-posts__button')}>
            View all blogs
          </Link>
        </div>

        <div className={cn('related-posts__posts')}>
          <BlogPosts posts={articles} />
        </div>

      </div>
    </section>
  );
};

export default SectionRelatedPosts;